import { Box, Chip, Tooltip } from '@mui/material';
import type { GridColDef } from '@mui/x-data-grid-pro';
import { CURRENCIES } from '@vy/types';
import { Price } from '../../../../../components/design/Price';
import { formatDate } from '../../../../../utils/date';
import type { CreditLedgerEntry } from './credit-ledger-entry';

export function getCreditsUsageColumns(): GridColDef<CreditLedgerEntry>[] {
  return [
    {
      field: 'date',
      headerName: 'Date',
      flex: 1,
      sortable: false,
      renderCell: (params) => formatDate(params.row.date, 'MMM D, YY'),
    },
    {
      field: 'invoiceRef',
      headerName: 'Invoice',
      flex: 1,
      sortable: false,
      renderCell: (params) => params.row.invoiceRef || '-',
    },
    {
      field: 'credit',
      headerName: 'Credit',
      flex: 1,
      sortable: false,
      renderCell: (params) =>
        params.row.credit == null ? '-' : <Price currency={CURRENCIES.Usd}>{params.row.credit}</Price>,
    },
    {
      field: 'debit',
      headerName: 'Debit',
      flex: 1,
      sortable: false,
      renderCell: (params) =>
        params.row.debit == null ? '-' : <Price currency={CURRENCIES.Usd}>{params.row.debit}</Price>,
    },
    {
      field: 'balance',
      headerName: 'Balance',
      flex: 1,
      sortable: false,
      renderCell: (params) => (
        <Price currency={CURRENCIES.Usd} sx={{ fontWeight: 600 }}>
          {params.row.balance}
        </Price>
      ),
    },
    {
      field: 'expiryDate',
      headerName: 'Expiry',
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const { expiryDate } = params.row;
        if (!expiryDate) return '-';
        const isExpired = expiryDate < new Date();
        return (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <span>{formatDate(expiryDate, 'MMM D, YY')}</span>
            {isExpired && <Chip label="Expired" size="small" color="error" />}
          </Box>
        );
      },
    },
    {
      field: 'note',
      headerName: 'Note',
      flex: 1.5,
      sortable: false,
      renderCell: (params) => {
        const note = params.row.note;
        if (note == null || note === '') {
          return '-';
        }
        return (
          <Tooltip title={note} placement="top" arrow>
            <Box
              sx={{
                width: '100%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {note}
            </Box>
          </Tooltip>
        );
      },
    },
  ];
}
